function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import { sortDate } from '@bydesign-ui/utils';
import { RangeState } from '../util';
import { BaseDate, FrameSelectedType } from './BaseDate';
import { PanelType } from './BasePanel';
export var MultipleDate = function (_BaseDate) {
  _inherits(MultipleDate, _BaseDate);

  var _super = _createSuper(MultipleDate);

  function MultipleDate() {
    var _this;

    _classCallCheck(this, MultipleDate);

    _this = _super.apply(this, arguments);
    _this.value = [];
    _this.trying = false;
    _this.tryingDate = [];
    _this.tryingValid = true;
    _this.presetTrying = false;
    _this.presetTryingDate = [];
    _this.presetTryingValid = true;
    return _this;
  }

  _createClass(MultipleDate, [{
    key: "setMultiplePanelUpdate",
    value: function setMultiplePanelUpdate(updater) {
      this.onUpdatePanelDate = updater;
    }
  }, {
    key: "updateValue",
    value: function updateValue(value) {
      var _this2 = this;

      if (this.equalValue(this.value, value || [])) {
        return;
      }

      var old = this.value;
      this.value = value || [];
      this.isValueValid = !this.value.some(function (item) {
        return _this2.isDisabled(item);
      });

      if (!this.equalValue(old, this.value)) {
        this.onUpdatePanelDate && this.onUpdatePanelDate(this, this.value);
      } else {
        this.repaintPanel();
      }
    }
  }, {
    key: "getValue",
    value: function getValue() {
      return this.value;
    }
  }, {
    key: "getTryingSelectedState",
    value: function getTryingSelectedState(date) {
      if (this.isSelected(date)) {
        return RangeState.SINGLE;
      }

      return RangeState.NONE;
    }
  }, {
    key: "getSelectedState",
    value: function getSelectedState(date) {
      if (this.isSelected(date)) {
        return RangeState.SINGLE;
      }

      return RangeState.NONE;
    }
  }, {
    key: "isDateSelected",
    value: function isDateSelected(date) {
      var _this3 = this;

      if (this.presetTrying) {
        return this.presetTryingDate.some(function (item) {
          return _this3.equalDate(item, date, PanelType.DATE);
        });
      }

      if (this.trying) {
        return this.tryingDate.some(function (item) {
          return _this3.equalDate(item, date, PanelType.DATE);
        });
      }

      return this.value.some(function (item) {
        return _this3.equalDate(item, date, PanelType.DATE);
      });
    }
  }, {
    key: "isMonthSelected",
    value: function isMonthSelected(date) {
      var _this4 = this;

      if (this.presetTrying) {
        return this.presetTryingDate.some(function (item) {
          return _this4.equalDate(item, date, PanelType.MONTH);
        });
      }

      if (this.trying) {
        return this.tryingDate.some(function (item) {
          return _this4.equalDate(item, date, PanelType.MONTH);
        });
      }

      return this.value.some(function (item) {
        return _this4.equalDate(item, date, PanelType.MONTH);
      });
    }
  }, {
    key: "isWeekSelected",
    value: function isWeekSelected(date) {
      var _this5 = this;

      if (this.presetTrying) {
        return this.presetTryingDate.some(function (item) {
          return _this5.equalDate(item, date, PanelType.WEEK);
        });
      }

      if (this.trying) {
        return this.tryingDate.some(function (item) {
          return _this5.equalDate(item, date, PanelType.WEEK);
        });
      }

      return this.value.some(function (item) {
        return _this5.equalDate(item, date, PanelType.WEEK);
      });
    }
  }, {
    key: "isYearSelected",
    value: function isYearSelected(date) {
      var _this6 = this;

      if (this.presetTrying) {
        return this.presetTryingDate.some(function (item) {
          return _this6.equalDate(item, date, PanelType.YEAR);
        });
      }

      if (this.trying) {
        return this.tryingDate.some(function (item) {
          return _this6.equalDate(item, date, PanelType.YEAR);
        });
      }

      return this.value.some(function (item) {
        return _this6.equalDate(item, date, PanelType.YEAR);
      });
    }
  }, {
    key: "setPanelSelected",
    value: function setPanelSelected(date, part) {
      var virtual = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      var disabled = this.isDisabled(date);

      if (disabled || virtual) {
        return;
      }

      var value = this.value.slice(0);

      for (var i = 0; i < value.length; i++) {
        var item = value[i];

        if (this.equalDate(item, date)) {
          value.splice(i, 1);
          this.resetTryingState();
          this.emit('value-change', value);
          return;
        }
      }

      value.push(date);
      this.resetTryingState();
      this.emit('value-change', value);
    }
  }, {
    key: "resetTryingState",
    value: function resetTryingState() {
      this.trying = false;
      this.tryingDate = [];
    }
  }, {
    key: "setPresetTrying",
    value: function setPresetTrying(presetTrying) {
      this.presetTrying = true;
      this.presetTryingDate = presetTrying;
      this.presetTryingValid = this.getIsValueValid(presetTrying);
      this.repaintPanel();
    }
  }, {
    key: "resetPresetTrying",
    value: function resetPresetTrying() {
      this.presetTrying = false;
      this.presetTryingDate = [];
      this.presetTryingValid = true;
      this.repaintPanel();
    }
  }, {
    key: "setPanelFrameSelected",
    value: function setPanelFrameSelected(dateList, part, type) {
      var _this7 = this;

      var virtual = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
      var value = this.value.slice(0);
      dateList.forEach(function (date) {
        var disabled = _this7.isDisabled(date);

        if (disabled) {
          return;
        }

        for (var i = 0; i < value.length; i++) {
          var item = value[i];

          if (_this7.equalDate(item, date)) {
            if (type !== FrameSelectedType.SELECT) {
              value.splice(i, 1);
            }

            return;
          }
        }

        if (type !== FrameSelectedType.UNSELECT) {
          value.push(date);
        }
      });

      if (virtual) {
        this.trying = true;
        this.tryingDate = value;
        this.repaintPanel();
      } else {
        this.resetTryingState();
        this.emit('value-change', value);
      }
    }
  }, {
    key: "isTrying",
    value: function isTrying() {
      return this.trying;
    }
  }, {
    key: "equalValue",
    value: function equalValue(sourceValue, compareValue) {
      var _this8 = this;

      if (sourceValue.length !== compareValue.length) {
        return false;
      }

      var source = sortDate(sourceValue);
      var compare = sortDate(compareValue);
      return !source.some(function (item, i) {
        return !_this8.equalDate(item, compare[i]);
      });
    }
  }, {
    key: "getIsValueValid",
    value: function getIsValueValid(date) {
      var _this9 = this;

      return date.every(function (item) {
        return !_this9.isDisabled(item);
      });
    }
  }]);

  return MultipleDate;
}(BaseDate);